import { render, staticRenderFns } from "./Sensibility.vue?vue&type=template&id=94fe1cb4"
import script from "./Sensibility.vue?vue&type=script&lang=js"
export * from "./Sensibility.vue?vue&type=script&lang=js"
import style0 from "./Sensibility.vue?vue&type=style&index=0&id=94fe1cb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports